// FE-SCRM-052 — TanStack Query hook for the Opportunities list view.

import { useQuery } from "@tanstack/react-query";

import { fetchOpportunityList } from "./api";
import type { OpportunityListResponse } from "./types";


export const OPPORTUNITY_LIST_QUERY_KEY = "sales-opportunity-list";


export function useOpportunityListQuery(
  query: URLSearchParams,
) {
  // The full query-string is the cache key — every filter / sort /
  // page change is a different snapshot of the list and we want
  // independent caching.
  const qs = query.toString();
  return useQuery<OpportunityListResponse>({
    queryKey: [OPPORTUNITY_LIST_QUERY_KEY, qs],
    queryFn: ({ signal }) => fetchOpportunityList(query, { signal }),
    staleTime: 30_000,
  });
}
